import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="hc-container py-32 text-center">
      <div className="text-7xl font-serif text-slate-300">404</div>
      <h1 className="mt-4 font-serif text-2xl font-semibold text-slate-900">Page not found</h1>
      <p className="mt-2 text-slate-600">The page you're looking for doesn't exist or was moved.</p>
      <Link to="/" className="mt-6 inline-flex btn-primary">Back to Home</Link>
    </div>
  );
}
